import moment from "moment"
import {
  getCountryList,
  getGenericListPath,
  getplaceOfPurchaseList,
  getstateList,
  mapStateToCountry,
} from "@/store/features/genericSlice"
import { isShowAnalyticsEventLoaded, validateField } from "@/utils/helper"
import { store } from "@/store"

// Analytics *********************

const editButtonAnalyticsEventInfo = type => {
  return JSON.stringify({
    eventAction: `my account:register offline kohler products:${type}:edit`,
    eventName: `my account:register offline kohler products:${type}:edit`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:register offline kohler products:${type}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  })
}
export const editButtonAnalyticsEventInfoStep = type => {
  const eventInfo = {
    eventAction: `my account:register offline kohler products:${type}:edit`,
    eventName: `my account:register offline kohler products:${type}:edit`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "edit",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:register offline kohler products:${type}`,
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}

const getBackToProductsAnalytics = (isSuccess, myProductsPath) => {
  const pageName = isSuccess
    ? "thank you for registering the products"
    : "top navigation"
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction: `my account:register offline kohler products:${pageName}:back to my products`,
    eventName: `my account:register offline kohler products:${pageName}:back to my products`,
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to my products",
    eventType: "navigation",
    internalLinkPosition: "register offline kohler products",
    internalLinkType: "my account:navigation",
    internalLinkURL:
      (myProductsPath?.indexOf("http") === -1 ? window.location.origin : "") +
      myProductsPath,
    internalLinkZoneName: `my account:register offline kohler products:${pageName}`,
  })
}

const getProductConfirmationEventInfo = (linkUrl, productData) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction:
      "my account:register offline kohler products:product registration summary:back to homepage",
    eventName:
      "my account:register offline kohler products:product registration summary:back to homepage",
    eventMsg: "n/a",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "back to homepage",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkURL:
      (linkUrl.indexOf("http") === -1 ? window.location.origin : "") + linkUrl,
    internalLinkZoneName:
      "my account:register offline kohler products:product registration summary",
  }
  const ProductInfo = []
  productData?.map(data => {
    const obj = {
      productDetails: data.productDetails.value || "n/a",
      serialNumber: data.serialNumber.value || "n/a",
      dealerName: data.dealerName.value || "n/a",
      dateOfPurchase: data.dateOfPurchase.value || "n/a",
      customerImage: data.customerImage || "n/a",
      uploadedImage: data.uploadedImage || "n/a",
    }
    ProductInfo.push(obj)
  })
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo: ProductInfo,
  })
}

const getOfflineReviewProductsAnalytics = (myProductsPath, productData) => {
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction:
      "my account:register offline kohler products:thank you for sharing the details:back to homepage",
    eventMsg: "n/a",
    eventName:
      "my account:register offline kohler products:thank you for sharing the details:back to homepage",
    eventStatus: "n/a",
    eventType: "navigation",
    internalLinkName: "back to homepage",
    internalLinkPosition: "register offline kohler products",
    internalLinkType: "my account:navigation",
    internalLinkURL:
      (myProductsPath?.indexOf("http") === -1 ? window.location.origin : "") +
      myProductsPath,
    internalLinkZoneName:
      "my account:register offline kohler products:thank you for sharing the details",
  }
  const ProductInfo = []
  productData?.map(data => {
    const obj = {
      productDetails: data.productDetails.value || "n/a",
      serialNumber: data.serialNumber.value || "n/a",
      dealerName: data.dealerName.value || "n/a",
      dateOfPurchase: data.dateOfPurchase.value || "n/a",
      customerImage: data.customerImage || "n/a",
      uploadedImage: data.uploadedImage || "n/a",
    }
    ProductInfo.push(obj)
  })
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    productInfo: ProductInfo,
  })
}

// step product information **********
const addProductInformationAnalytics = (
  action,
  productData,
  status,
  errorsList
) => {
  if (status && status !== "success") {
    errorsList = errorsList.join(":")?.toLowerCase() || "n/a"
  }

  const eventInfo = {
    eventAction:
      "my account:register offline kohler products:product information:next step",
    eventName:
      "my account:register offline kohler products:product information:next step",
    eventType: "navigation",
    eventMsg: errorsList || "n/a",
    eventStatus: status,
    internalLinkName: "next step",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName:
      "my account:register offline kohler products:product information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
  const ProductInfo = []
  productData?.map(data => {
    const obj = {
      productDetails: data.productDetails.value || "n/a",
      serialNumber: data.serialNumber.value || "n/a",
      dealerName: data.dealerName.value || "n/a",
      dateOfPurchase: data.dateOfPurchase.value || "n/a",
      customerImage: data.customerImage || "n/a",
      uploadedImage: data.uploadedImage || "n/a",
    }
    ProductInfo.push(obj)
  })

  const { adobeDataLayer: { getState } = {} } = window
  const page =
    action === "cmp:show"
      ? window.pageObj
      : (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: ProductInfo,
  })
  // delete window.pageObj
}
// product form
const getRemoveOfflineProductsAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction:
      "my account:register offline kohler products:product information:remove",
    eventName:
      "my account:register offline kohler products:product information:remove",
    eventType: "informative",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "remove",
    internalLinkPosition: "register offline kohler products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName:
      "my account:register offline kohler products:product information",
    internalLinkURL: "n/a",
  })
}

const modalNumberSupportLinkEventInfo = JSON.stringify({
  eventAction:
    "my account:register offline kohler products:product information:how to find your model number",
  eventName:
    "my account:register offline kohler products:product information:how to find your model number",
  eventType: "navigation",
  eventMsg: "n/a",
  eventStatus: "n/a",
  internalLinkName: "how to find your model number",
  internalLinkPosition: "register products",
  internalLinkType: "my account:navigation",
  internalLinkZoneName:
    "my account:register offline kohler products:product information",
  internalLinkURL: "n/a",
  clickInternalLinks: "true",
})

const getAddAnotherProductAnalytics = () => {
  return JSON.stringify({
    clickInternalLinks: "true",
    eventAction:
      "my account:register offline kohler products:product information:add another product to register",
    eventName:
      "my account:register offline kohler products:product information:add another product to register",
    eventType: "informative",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "add another product to register",
    internalLinkPosition: "register offline kohler products",
    internalLinkType: "my account:navigation",
    internalLinkURL: "n/a",
    internalLinkZoneName:
      "my account:register offline kohler products:product information",
  })
}

// step registrationInformation***
const addRegistrationInformationAnalytics = (
  productDetails,
  action,
  status,
  errorsList
) => {
  if (status && status !== "success") {
    errorsList = errorsList.join("|")?.toLowerCase() || "n/a"
  }
  const eventInfo = {
    eventAction:
      "my account:register offline kohler products:personal information:next step",
    eventName:
      "my account:register offline kohler products:personal information:next step",
    eventType: "navigation",
    eventMsg: errorsList || "n/a",
    eventStatus: status,
    internalLinkName: "next step",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName:
      "my account:register offline kohler products:personal information",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  const ProductInfo = []
  productDetails?.map(data => {
    const obj = {
      productDetails: data.productDetails.value || "n/a",
      serialNumber: data.serialNumber.value || "n/a",
      dealerName: data.dealerName.value || "n/a",
      dateOfPurchase: data.dateOfPurchase.value || "n/a",
      customerImage: data.customerImage || "n/a",
      uploadedImage: data.uploadedImage || "n/a",
    }
    ProductInfo.push(obj)
  })

  const { adobeDataLayer: { getState } = {} } = window
  const page =
    action === "cmp:show"
      ? window.pageObj
      : (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: ProductInfo,
  })
  // delete window.pageObj
}

// step reviewInformation
const getReviewRegistrationEventInfo = (type, linkUrl) => {
  return JSON.stringify(addReviewRegistrationEventInfo(type, linkUrl))
}

const addReviewRegistrationEventInfo = (
  type,
  linkUrl,
  clickInternalLinks = "true"
) => {
  const linkFor = type?.toLowerCase()
  return {
    eventAction: `my account:register offline kohler products:review and register:${linkFor}`,
    eventName: `my account:register offline kohler products:review and register:${linkFor}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: linkFor,
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName: `my account:register offline kohler products:review and register`,
    internalLinkURL: linkUrl,
    clickInternalLinks,
  }
}

const addReviewRegistrationAnalytics = (
  action,
  status,
  productData,
  message
) => {
  const eventInfo = {
    eventAction:
      "my account:register offline kohler products:review and register:submit registration",
    eventName:
      "my account:register offline kohler products:review and register:submit registration",
    eventType: "navigation",
    eventMsg: message || "n/a",
    eventStatus: status || "n/a",
    internalLinkName: "submit registration",
    internalLinkPosition: "register products",
    internalLinkType: "my account:navigation",
    internalLinkZoneName:
      "my account:register offline kohler products:review and register",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }

  const ProductInfo = []
  productData?.map(data => {
    const obj = {
      productDetails: data.productDetails.value || "n/a",
      serialNumber: data.serialNumber.value || "n/a",
      dealerName: data.dealerName.value || "n/a",
      dateOfPurchase: data.dateOfPurchase.value || "n/a",
      customerImage: data.customerImage || "n/a",
      uploadedImage: data.uploadedImage || "n/a",
    }
    ProductInfo.push(obj)
  })

  const { adobeDataLayer: { getState } = {} } = window
  const page =
    action === "cmp:show"
      ? window.pageObj
      : (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: action,
    page,
    eventInfo,
    productInfo: ProductInfo,
  })
  // delete window.pageObj
}

// END--Analytics *********************

// step product information **********
const productInfoHandleSubmit = (data, staticText) => {
  let valid = true
  const newData = []
  const errorMessage = []
  data.map(formItem => {
    const obj = {}
    if (!formItem.productDetails.value) {
      obj.productDetails = {
        ...formItem.productDetails,
        error: true,
        message: props.i18n.productError,
      }
      valid = false
      errorMessage.push(props.i18n.productError)
    }
    if (!formItem.dateOfPurchase.value) {
      obj.dateOfPurchase = {
        ...formItem.dateOfPurchase,
        error: true,
        message: props.i18n.placeOfPurchaseError,
      }
      valid = false
      errorMessage.push(staticText.placeOfPurchaseError)
    }
    newData.push({ ...formItem, ...obj })
  })
  return { newData: newData, valid: valid, errorMessage: errorMessage }
}

const getLocations = async () => {
  await store.dispatch(getGenericListPath())
  const { payload: countryList } = await store.dispatch(getCountryList())
  const { payload: stateList } = await store.dispatch(getstateList())
  await store.dispatch(getplaceOfPurchaseList())
  if (countryList.length)
    store.dispatch(mapStateToCountry({ countryList, stateList }))
}

// register-offline-products
const getProductDetails = (productDetail = []) => {
  const productDetails = []
  if (productDetail && productDetail.length > 0) {
    productDetail.forEach(item => {
      const productList = {}
      productList.productDetail = item.productDetails?.value
      productList.serialNumber =
        item.serialNumber?.value?.trim().length > 0
          ? item.serialNumber?.value
          : "N/A"
      productList.dealerName =
        item.dealerName?.value?.trim().length > 0
          ? item.dealerName?.value
          : "N/A"
      productList.dateOfPurchase = moment(item.dateOfPurchase?.value)?.format(
        "DD/MM/YYYY"
      )
      productList.invoiceData = item.productImages

      productDetails.push(productList)
    })
  }
  return productDetails
}

const submitRegistrationGenericError = (productDetails, errorMsg) => {
  const isShowEvent = isShowAnalyticsEventLoaded()
  if (!isShowEvent) {
    addReviewRegistrationAnalytics(
      "cmp:click",
      "failure",
      productDetails,
      errorMsg
    )
  }
}

export {
  getBackToProductsAnalytics,
  getProductConfirmationEventInfo,
  getOfflineReviewProductsAnalytics,
  addProductInformationAnalytics,
  productInfoHandleSubmit,
  getRemoveOfflineProductsAnalytics,
  modalNumberSupportLinkEventInfo,
  getAddAnotherProductAnalytics,
  getLocations,
  addRegistrationInformationAnalytics,
  editButtonAnalyticsEventInfo,
  getReviewRegistrationEventInfo,
  getProductDetails,
  addReviewRegistrationAnalytics,
  submitRegistrationGenericError,
  addReviewRegistrationEventInfo,
}
